import SyncRepository from './sync'
import Vendor from './vendor'

/* global $ SyncRepository Vendor */
$(() => {
  SyncRepository($('.js_sync-repository'))
  Vendor($('.js_vendor-container'))
})
